import { gql } from '@apollo/client';
import { graphql } from '@xolv-mybrightlink/common';
import { PeerProfile } from '../model/PeerProfile';
import { CommunityFilter } from '../model/CommunityFilter';
import { MIN_COMMUNITY_LOOKUP_DISTANCE_IN_MILES } from './CommunityFilterService';

const PEER_PROFILE_INFO_QUERY = gql`
  query userProfile($guid: String) {
    userProfile(guid: $guid) {
      id
      guid
      userGuid
      firstName
      lastName
      biography
      city
      zipCode
      state
      country
      formattedAddress
      userInterests
      peerStatus
      userAnalyticsId
      communityOptIn
      patients {
        id
        firstName
        lastName
        gender
        dateOfBirth
        strengths
        communicationLevel
        interactionLevel
        selfCareAssistanceLevel
      }
    }
  }
`;

const FIND_NEAR_BY_PROFILE_QUERY = gql`
  query findNearByPeersWithFilter($filter: CommunityFilterPreferenceInput) {
    findNearByPeersWithFilter(filter: $filter) {
      id
      guid
      firstName
      lastName
      biography
      city
      zipCode
      state
      country
      formattedAddress
      peerStatus
      userInterests
      patients {
        id
        firstName
        lastName
        gender
        dateOfBirth
        strengths
        communicationLevel
        interactionLevel
        selfCareAssistanceLevel
      }
    }
  }
`;

export const queryPeerProfileInfo = async (
  peerGuid: string,
): Promise<PeerProfile> => {
  const peerProfileInfo = await graphql.query<{ userProfile: PeerProfile }>({
    query: PEER_PROFILE_INFO_QUERY,
    variables: {
      guid: peerGuid,
    },
    fetchPolicy: 'no-cache',
  });
  return peerProfileInfo.data.userProfile;
};

export const findNearByProfile = async (
  filter: CommunityFilter,
): Promise<PeerProfile[]> => {
  const discoveredProfiles = await graphql.query<{
    findNearByPeersWithFilter: PeerProfile[];
  }>({
    query: FIND_NEAR_BY_PROFILE_QUERY,
    variables: {
      filter: {
        locationData: {
          city: filter.locationData?.city,
          zip_code: filter.locationData?.zipCode,
          state: filter.locationData?.state,
          country: filter.locationData?.country,
          longitude: filter.locationData?.longitude,
          latitude: filter.locationData?.latitude,
        },
        distanceInMiles:
          filter.distanceInMiles > 0
            ? filter.distanceInMiles
            : MIN_COMMUNITY_LOOKUP_DISTANCE_IN_MILES,
        ageRangeStartInMonths: filter.ageRangeStartInMonths,
        ageRangeEndInMonths: filter.ageRangeEndInMonths,
      },
    },
    fetchPolicy: 'no-cache',
  });
  return discoveredProfiles.data.findNearByPeersWithFilter;
};
